
import AppContactSearch from "@/components/contacts/ContactSearchWithBrowseAndCreate.vue";
import { Contact } from "@/models/base";
import { Purchase } from "@/models/base";
import { AllContactsService } from "@/services/all-contacts-service";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			contactGroupId: 2
		};
	},
	props: {
		value: {
			type: Object as () => Purchase,
			required: true
		}
	},
	methods: {

		async onInput(value:Contact) {
			value = await AllContactsService.getContactByID(value.ID);
			this.value.ContactID = value.ID;
			this.value.Contact = value;
			this.value.CurrencyID = value.CurrencyID;
			let expDate = new Date(this.value.InvoiceDate.getTime());
			expDate.setDate(expDate.getDate() + value.PaymentDays);
			this.value.ExpirationDate = expDate;
		}
	},
	mounted(){
		if(this.value.Contact){
			this.contactGroupId = this.value.Contact.GroupID || 2;
		}
	},
	components: {
		AppContactSearch
	},
	i18nEx: {
		componentPrefix: "components.purchases"
	}
});
